import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper, Alert } from '@mui/material';
import { useUser } from '../contexts/UserContext';
import { getRoleDisplayName } from '../utils/roleUtils';

const ContactForm: React.FC = () => {
  const auth = useUser();
  const { user, selectedClientId } = useUser();
  const [description, setDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Get the current client assignment
  const currentAssignment = user?.client_assignments?.find(
    ca => ca.client_id === selectedClientId
  );

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // TODO: Implement form submission
      console.log('Form submitted:', {
        name: auth.user?.profile.name,
        email: auth.user?.profile.email,
        agency: currentAssignment?.client.agency_name,
        role: currentAssignment?.role,
        description
      });
      
      // Clear form
      setDescription('');
      
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Paper elevation={2} className="p-6">
      <Typography variant="h5" gutterBottom>Contact Support</Typography>
      <Alert severity="info" className="mb-4">
        Our support team typically responds within 1 business day.
      </Alert>
      
      <form onSubmit={handleSubmit}>
        <Box className="space-y-4">
          {/* Display user info */}
          <TextField
            fullWidth
            label="Username"
            value={auth.user?.profile.email?.split('@')[0] || ''}
            disabled
            variant="filled"
          />
          
          <TextField
            fullWidth
            label="Email"
            value={auth.user?.profile.email || ''}
            disabled
            variant="filled"
          />

          <TextField
            fullWidth
            label="Agency"
            value={currentAssignment ? `${currentAssignment.client.agency_name} (${getRoleDisplayName(currentAssignment.role)})` : 'No Agency Selected'}
            disabled
            variant="filled"
          />
          
          {/* Description field */}
          <TextField
            fullWidth
            label="Describe Issue"
            multiline
            rows={6}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            sx={{
              '& .MuiInputBase-root': {
                minHeight: '160px' // Approximately 6 lines of text
              }
            }}
          />
          
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isSubmitting}
            className="mt-4"
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default ContactForm;
